<template>
  <div class="ts-space-y-3">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 required">{{
          $t('floatingCashier.floatingDate')
        }}</label>
        <a-date-picker v-model="model.floating_date" show-time format="DD-MM-YYYY HH:mm:ss"
          valueFormat="DD-MM-YYYY HH:mm:ss" class="ts-w-full"></a-date-picker>
        <div class="validate" v-if="errors.has('floating_date')">
          {{ errors.first('floating_date') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-mb-0 required">{{
              $t('floatingCashier.cashier')
            }}</label>
            <a-select v-model="model.cashier_id" :options="cashiers" show-search option-filter-prop="children"
              class="ts-w-full" :class="{
                'is-invalid': errors.has('cashier_id')
              }" placeholder="Select"></a-select>
            <div class="validate" v-if="errors.has('cashier_id')">
              {{ errors.first('cashier_id') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-mb-0">{{
              $t('floatingCashier.openingMemberCard')
            }}</label>
            <input v-model.number="model.opening_member_card" type="number" class="form-control"
              style="height: 32px;" />
            <div class="validate" v-if="errors.has('opening_member_card')">
              {{ errors.first('opening_member_card') }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-mb-0 required">{{
              $t('floatingCashier.openingUsdBalance')
            }}</label>
            <ts-currency-input v-model.number="model.opening_usd_balance" class="form-control ts-text-right"
              style="min-width: 100px;height: 32px;" currency="$" :precision="2" />
            <div class="validate" v-if="errors.has('opening_usd_balance')">
              {{ errors.first('opening_usd_balance') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-mb-0 required">{{
              $t('floatingCashier.openingKhrBalance')
            }}</label>
            <ts-currency-input v-model.number="model.opening_khr_balance" class="form-control ts-text-right"
              style="min-width: 100px;height: 32px;" currency="៛" :precision="0" />
            <div class="validate" v-if="errors.has('opening_khr_balance')">
              {{ errors.first('opening_khr_balance') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0">{{
          $t('floatingCashier.remark')
        }}</label>
        <textarea v-model="model.remark" rows="3" class="form-control" placeholder="Note something here"></textarea>
        <div class="validate" v-if="errors.has('remarks')">
          {{ errors.first('remarks') }}
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh mt-3">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button color="primary" v-if="isUpdate" @click.prevent="onUpdate" :waiting="loading">
          {{ $t('update') }}
        </ts-button>
        <ts-button color="primary" v-if="!isUpdate" outline :waiting="loading" @click.prevent="onSaveAddNew">
          {{ $t('save_add_new') }}
        </ts-button>
        <ts-button color="primary" v-if="!isUpdate" :waiting="loading" @click.prevent="onSave">
          {{ $t('save') }}
        </ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { isEmpty } from 'lodash'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'floating-cashier-form',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        floating_date: moment().format('DD-MM-YYYY HH:mm:ss'),
        cashier_id: null,
        opening_usd_balance: 0,
        closing_usd_balance: null,
        opening_khr_balance: 0,
        closing_khr_balance: null,
        cash_usd_in: null,
        cash_usd_out: null,
        cash_khr_in: null,
        cash_khr_out: null,
        opening_member_card: 0,
        closing_member_card: null,
        member_card_in: null,
        member_card_out: null,
        remark: null,
      }
    }
  },
  created() {
    this.getPreData()
    this.setEditData()
  },
  computed: {
    ...mapState('floating/floatingCashier', ['edit_data', 'formViewDatas']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    },
    cashiers() {
      if (this.formViewDatas['cashiers']) {
        return this.formViewDatas['cashiers'].map(el => ({
          value: el.user_id,
          label: el.employee_name_en
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('floating/floatingCashier', ['getFormViewModel']),
    async getPreData() {
      this.loading = true
      await this.getFormViewModel({ index: undefined, params: {} })
      this.loading = false
    },
    onSave() {
      this.loading = true
      this.$store
        .dispatch('floating/floatingCashier/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onSaveAddNew() {
      this.errors = new Errors()
      this.loading = true
      this.$store
        .dispatch('floating/floatingCashier/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.loading = true
      this.$store
        .dispatch('floating/floatingCashier/update', {
          id: this.edit_data.floating_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.floating_date = moment(this.edit_data.floating_date, 'DD-MM-YYYY hh:mm:ss A').format('DD-MM-YYYY HH:mm:ss')
        this.model.cashier_id = this.edit_data.cashier_id
        this.model.opening_usd_balance = this.edit_data.opening_usd_balance
        this.model.closing_usd_balance = this.edit_data.closing_usd_balance
        this.model.opening_khr_balance = this.edit_data.opening_khr_balance
        this.model.closing_khr_balance = this.edit_data.closing_khr_balance
        this.model.cash_usd_in = this.edit_data.cash_usd_in
        this.model.cash_usd_out = this.edit_data.cash_usd_out
        this.model.cash_khr_in = this.edit_data.cash_khr_in
        this.model.cash_khr_out = this.edit_data.cash_khr_out
        this.model.opening_member_card = this.edit_data.opening_member_card
        this.model.closing_member_card = this.edit_data.closing_member_card
        this.model.member_card_in = this.edit_data.member_card_in
        this.model.member_card_out = this.edit_data.member_card_out
        this.model.remark = this.edit_data.remark
      }
    },
    clearInput() {
      this.model.floating_date = moment().format('DD-MM-YYYY HH:mm:ss')
      this.model.cashier_id = null
      this.model.opening_usd_balance = 0
      this.model.closing_usd_balance = null
      this.model.opening_khr_balance = 0
      this.model.closing_khr_balance = null
      this.model.cash_usd_in = null
      this.model.cash_usd_out = null
      this.model.cash_khr_in = null
      this.model.cash_khr_out = null
      this.model.opening_member_card = 0
      this.model.closing_member_card = null
      this.model.member_card_in = null
      this.model.member_card_out = null
      this.model.remark = null
    }
  },
}
</script>
